import { useTheme } from 'next-themes';
import { Toaster as Sonner, type ToasterProps } from 'sonner';

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme();

  return (
    <>
      <style jsx global>{`
        .toaster [data-sonner-toast] {
          font-size: 12px !important;
        }

        /* Ensure long toast messages wrap instead of being truncated */
        .toaster [data-sonner-toast] [data-content] {
          min-width: 0 !important;
          overflow: visible !important;
        }

        .toaster [data-sonner-toast] [data-title] {
          white-space: normal !important;
          overflow-wrap: anywhere !important;
          word-break: break-word !important;
          line-clamp: unset !important;
          -webkit-line-clamp: unset !important;
        }

        .toaster [data-sonner-toast] button {
          font-size: 11px !important;
        }

        /* Larger font size for mobile devices */
        @media (max-width: 768px) {
          .toaster [data-sonner-toast] {
            font-size: 16px !important;
          }

          .toaster [data-sonner-toast] button {
            font-size: 14px !important;
          }
        }

        /* Neutral backgrounds for all toast types */
        .toaster [data-sonner-toast][data-type='error'] {
          background: hsl(0, 0%, 96%) !important;
          border-color: hsl(0, 0%, 90%) !important;
          color: hsl(0, 0%, 20%) !important;
        }

        .toaster [data-sonner-toast][data-type='success'] {
          background: hsl(0, 0%, 96%) !important;
          border-color: hsl(0, 0%, 90%) !important;
          color: hsl(0, 0%, 20%) !important;
        }

        .toaster [data-sonner-toast][data-type='warning'] {
          background: hsl(0, 0%, 96%) !important;
          border-color: hsl(0, 0%, 90%) !important;
          color: hsl(0, 0%, 20%) !important;
        }

        .toaster [data-sonner-toast][data-type='info'] {
          background: hsl(0, 0%, 96%) !important;
          border-color: hsl(0, 0%, 90%) !important;
          color: hsl(0, 0%, 20%) !important;
        }

        /* Dark mode neutral backgrounds */
        [data-theme='dark'] .toaster [data-sonner-toast][data-type='error'],
        [data-theme='dark'] .toaster [data-sonner-toast][data-type='success'],
        [data-theme='dark'] .toaster [data-sonner-toast][data-type='warning'],
        [data-theme='dark'] .toaster [data-sonner-toast][data-type='info'] {
          background: hsl(0, 0%, 15%) !important;
          border-color: hsl(0, 0%, 25%) !important;
          color: hsl(0, 0%, 90%) !important;
        }
      `}</style>
      <Sonner
        theme={theme as ToasterProps['theme']}
        className="toaster group"
        style={
          {
            '--normal-bg': 'var(--popover)',
            '--normal-text': 'var(--popover-foreground)',
            '--normal-border': 'var(--border)',
          } as React.CSSProperties
        }
        {...props}
      />
    </>
  );
};

export { Toaster };
